export enum FormType {
    REGION = 'REGION',
    REFERENCE_NUMBER_DOMESTIC = 'REFERENCE_NUMBER_DOMESTIC',
    REFERENCE_NUMBER_INTERNATIONAL = 'REFERENCE_NUMBER_INTERNATIONAL',
    AFFECTED_ITEMS = 'AFFECTED_ITEMS',
    AFFECTED_ITEMS_DAMAGE_DOMESTIC = 'AFFECTED_ITEMS_DAMAGE_DOMESTIC',
    AFFECTED_ITEMS_DAMAGE_INTERNATIONAL = 'AFFECTED_ITEMS_DAMAGE_INTERNATIONAL',
    AFFECTED_ITEMS_INVOICE_ERROR_INTERNATIONAL = 'AFFECTED_ITEMS_INVOICE_ERROR_INTERNATIONAL',
    AFFECTED_ITEMS_QUALITY = 'AFFECTED_ITEMS_QUALITY',
    AFFECTED_ITEMS_QUANTITY_DOMESTIC = 'AFFECTED_ITEMS_QUANTITY_DOMESTIC',
    AFFECTED_ITEMS_QUANTITY_INTERNATIONAL = 'AFFECTED_ITEMS_QUANTITY_INTERNATIONAL',
    AFFECTED_ITEMS_ORDER_ENTRY_DOMESTIC = 'AFFECTED_ITEMS_ORDER_ENTRY_DOMESTIC',
    ORDER_ENTRY_DOMESTIC = 'ORDER_ENTRY_DOMESTIC',
    ORDER_ENTRY_INTERNATIONAL = 'ORDER_ENTRY_INTERNATIONAL',
    ITEM_OR_QUANTITY_DOMESTIC = 'ITEM_OR_QUANTITY_DOMESTIC',
    ITEM_OR_QUANTITY_INTERNATIONAL = 'ITEM_OR_QUANTITY_INTERNATIONAL',
    PRODUCT_DATING_DOMESTIC = 'PRODUCT_DATING_DOMESTIC',
    PRODUCT_DATING_INTERNATIONAL = 'PRODUCT_DATING_INTERNATIONAL',
    PRODUCT_DAMAGE_DOMESTIC = 'PRODUCT_DAMAGE_DOMESTIC',
    PRODUCT_DAMAGE_INTERNATIONAL = 'PRODUCT_DAMAGE_INTERNATIONAL',
    PRODUCT_TEMPERATURE_DOMESTIC = 'PRODUCT_TEMPERATURE_DOMESTIC',
    PRODUCT_TEMPERATURE_INTERNATIONAL = 'PRODUCT_TEMPERATURE_INTERNATIONAL',
    DELIVERY_ERROR_DOMESTIC = 'DELIVERY_ERROR_DOMESTIC',
    DELIVERY_ERROR_INTERNATIONAL = 'DELIVERY_ERROR_INTERNATIONAL',
    DOCUMENTATION_INTERNATIONAL = 'DOCUMENTATION_INTERNATIONAL',
    INVOICE_ERROR_DOMESTIC = 'INVOICE_ERROR_DOMESTIC',
    INVOICE_ERROR_INTERNATIONAL = 'INVOICE_ERROR_INTERNATIONAL',
    BILLING_ADJUSTMENT_DOMESTIC = 'BILLING_ADJUSTMENT_DOMESTIC',
    QUALITY_INTERNATIONAL = 'QUALITY_INTERNATIONAL',
    ESKER_DISCREPANCY_DOMESTIC = 'ESKER_DISCREPANCY_DOMESTIC',
    LARGE_INSTRUMENT_WAREHOUSE_DISCREPANCY = 'LARGE_INSTRUMENT_WAREHOUSE_DISCREPANCY',
    SUMMARY = 'SUMMARY',
    SUBMITTING = 'SUBMITTING'
}
